






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AddressDto } from '@/api';
import AddressField from '@/views/account/user/AddressField.vue';

@Component({
  components: {AddressField},
})
export default class AddressEdit extends Vue {
  @Prop({required: true})
  private address!: AddressDto;
  private allowedCountryCodes = ['AT'];

  @Watch('address', {deep: true})
  public onAddressChange(newAddress: AddressDto) {
    this.$emit('change', newAddress);
  }

  get hasSpecialSalutation() {
    return !!this.address.salutation && this.address.salutation !== this.$t('message.userData.salutationValue.mrs') &&
      this.address.salutation !== this.$t('message.userData.salutationValue.mr');
  }
}
